
<div class="edit-page-root-container system-settings-edit-root-container">
  <div class="page-content">
    <div class="page-header">
      <button mat-button class="nav-button" disabled>
        <img src="assets/images/menu/svg/display-order.svg" style="width: 24px;">
      </button>
      <div class="title">
        Sale Item Display Order
      </div>
      <div class="action-btn-container">
        <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
        <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
      </div>
    </div>
    <div class="page-details">
      <div class="detail-section general-settings">
        <form class="edit-form" *ngIf="itemClassForm" [formGroup]="itemClassForm">
          <div class="content-container">

            <div class="input-group">
              <div class="select-box">
                <div class="input-box-left">
                  <mat-form-field style="width: 95%;">
                    <input matInput type="text" placeholder="Select Menu" formControlName="menu_department"
                      [matAutocomplete]="menuDeptAuto" (input)="filterMenuDepartments()"
                      (focus)="filterMenuDepartments()">
                    <button *ngIf="menuDepartmentControl.value" (click)="clearMenuDepartment()" matSuffix
                      mat-icon-button aria-label="Clear">
                      <mat-icon style="color: rgb(29 28 28 / 38%); font-weight: 500; font-size: 22px;">close</mat-icon>
                    </button>
                    <mat-autocomplete [displayWith]="displayMenuDepartmentName" #menuDeptAuto="matAutocomplete">
                      <mat-option *ngFor="let dept of filteredMenuDepartments" [value]="dept">
                        <span>{{dept.name}}</span>
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="menuDepartmentControl.hasError('required')">
                      Please select a menu.
                    </mat-error>
                    <mat-error *ngIf="menuDepartmentControl.hasError('invalidMenuDepartment')">
                      Please select a valid menu from the list.
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="input-box-right">
                  <mat-form-field style="width: 95%;">
                    <input type="text" placeholder="Item class" aria-label="Subclass" matInput
                      formControlName="sub_class" [matAutocomplete]="auto">
                    <button *ngIf="subClassControl.value" (click)="clearSubClass()" matSuffix mat-icon-button
                      aria-label="Clear">
                      <mat-icon style="color: rgb(29 28 28 / 38%); font-weight: 500; font-size: 22px;">close</mat-icon>
                    </button>
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySubClass">
                      <mat-option *ngFor="let option of filteredSubClasses | async" [value]="option">
                        {{ option.name }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="subClassControl.hasError('required')">
                      Please select a item class.
                    </mat-error>
                    <mat-error *ngIf="subClassControl.hasError('invalidSubClass')">
                      Please select a valid item class from the list.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <br />
              <div cdkDropList cdkDropListOrientation="mixed" class="grid" (cdkDropListDropped)="drop($event)">
                @if (message) {
                <div class="message">{{ message }}</div>
                }
                @for (item of saleItemDisplayList; track item) {
                <div class="item-cell" cdkDrag
                  [ngStyle]="{'background-color': item.bg_color, color: item.fg_color, 'width': 'calc((100% / ' + numberOfColumns + ') - 10px)'}">
                  <div class="item-code">{{ item.code }}</div>
                  <div class="item-name">{{ item.name }}</div>
                  @if (item.fixed_price!==null) {
                  <div class="item-price">{{item.fixed_price}}$</div>
                  }
                </div>
                }

              </div>
            </div>
            <!-- </div> -->

          </div>
        </form>
      </div>
    </div>
  </div>